<template>
  <q-btn :color="color"
         :text-color="textColor"
         :disable="disable"
         :loading="loading"
         :label="label"
         :icon="icon"
         :size="size"
         :align="align"
         :class="customClass"
         :style="customStyle"
         :padding="padding"
         :unelevated="unelevated"
         :round="round"
         :outline="outline"
         v-on="$listeners" >
    <slot />
  </q-btn>
</template>

<script>
export default {
  name: 'RButton',
  props: {
    label: String,
    icon: String,
    disable: Boolean,
    loading: Boolean,
    color: String,
    textColor: String,
    size: String,
    align: {
      type: String,
      validator: value => ['left', 'right', 'center', 'around', 'between', 'evenly'].includes(value),
    },
    padding: String,
    unelevated: Boolean,
    round: Boolean,
    outline: Boolean,
    customClass: [String, Object, Array],
    customStyle: [String, Object],
  },
};
</script>
